<div [class]="'e-btn-group' + cssClass"
     [formGroup]="form">
  @for (item of keyList; track item) {
    <input type="checkbox"
           title="{{ item.text | translate }}"
           [id]="id + '-' + fieldsEnum[item.value]"
           [name]="id + '-' + fieldsEnum[item.value]"
           [formControlName]="fieldsEnum[item.value]"
           [value]="item.value"/>
    <label class="e-btn d-flex align-items-center"
           [ngClass]="{
              'fixed-width': fixedWidth,
              'inline': inline,
              'disabled': form.get(fieldsEnum[item.value]).disabled
           }"
           [for]="id + '-' + fieldsEnum[item.value]">{{ item.text | translate }}</label>
  }
</div>
